import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import * as _ from 'lodash';
import { PublicPartnerApiService } from './publicpartnerapi.service';
import { Store } from '@ngrx/store';
import { filter, take } from 'rxjs/operators';
import { getAccountPanelURL } from '../../@store/partner/partner.selectors';
import { environment } from '../../../environments/environment';

export interface PublicApiErrorResponse extends HttpErrorResponse {
  method: string;
}


@Injectable({
  providedIn: 'root'
})
export class UserStoreApiService extends PublicPartnerApiService {
  constructor(http: HttpClient, store: Store) {
    super(http, store);

    store.select(getAccountPanelURL).pipe(
      filter(url => url !== undefined),
      take(1)
    ).subscribe(url => {
      this.current_endpoint = url;

      if (environment.useCorsProxy && !(window as unknown as any).Cypress) {
        this.current_endpoint = environment.corsProxyUrl + this.current_endpoint;
      }
    })

  }
}
